export default __webpack_public_path__ + "static/img_0-b5729d4816b6ee5db243e51ce4d12f4c.png";